// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"2dd6ccf4","368":"54577bd8","513":"ecff5bcf","674":"195922f0","703":"087aae89","760":"d19721e5","787":"21f0e217","922":"506ba8d5"}[chunkId] + ".chunk.js";
};